import mutationEvents from 'mutation-events'; // Fixes Chrome's depreciation of DOM mutation events

import './modules';
import './packs/turbo';
import "./controllers";

// console.log('application.js test');
import "./controllers"
